import { compose, withState } from 'recompose';
import { connect } from 'react-redux';
import ActivityGroupList from './CoachPanel';

const mapStateToProps = ({ entities }) => ({
  clubActivityGroups: entities.activityGroups
});

export default compose(connect(mapStateToProps), withState('coachGroups', 'setCoachGroups', []))(ActivityGroupList);



// WEBPACK FOOTER //
// ./src/components/CoachPanel/CoachPanelContainer.js